import type { Writable } from "svelte/store";

export function trackAttribute<K>(
  node: HTMLElement,
  options: { attribute: string; store: Writable<K>; value: (store: K) => any },
) {
  const destroy = options.store.subscribe((s) => {
    setAttribute(node, { [options.attribute]: options.value(s) });
  });

  return { destroy };
}

/**
 * Properties that are set on the DOM node directly instead of using setAttribute
 */
const DOM_PROPERTIES = new Set([
  "value",
  "checked",
  "selected",
  "innerHTML",
  "outerHTML",
  "innerText",
  "textContent",
  "className",
  "href",
]);

export function setAttributeOrProperty(node: HTMLElement, key: string, value: any) {
  if (DOM_PROPERTIES.has(key)) {
    node[key] = value;
  } else if (value === false) {
    node.removeAttribute(key);
  } else {
    node.setAttribute(key, value);
  }
}

export function setAttribute(node: HTMLElement, attributes: { [key: string]: any }) {
  Object.keys(attributes).forEach((key) => {
    setAttributeOrProperty(node, key, attributes[key]);
  });
}
